import { Injectable, Type } from '@angular/core';
import { CarSelectRaStepComponent } from 'src/app/_components/remote-action-step/car-select-ra-step/car-select-ra-step.component';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { Car } from 'src/app/_model/car';

@Injectable()
export class CarSelectRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep
{
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return CarSelectRaStepComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
